import { Input } from "antd";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { editOrDeleteMoneyTransfer, getTransferBalance } from "../../API  Functions/accountingFunctions";

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 999,
    },
    container: {
        width: "500px",
        padding: "30px",
        borderRadius: "18px",
        margin: "0 auto",
        backgroundColor: "#ffffff",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
    },
    input: {
        width: "100%",
        marginBottom: "20px",
    },
};

const EditMoneyModal = ({ isOpen, onClose, record, onUpdate }) => {
    const { t } = useTranslation();

    const [amount, setAmount] = useState(record?.amount || "");
    const [remarks, setRemarks] = useState(record?.remarks || "");

    const [balance, setBalance] = useState(null);
    const [loadingBalance, setLoadingBalance] = useState(false);


    useEffect(() => {
        if (record) {
            setAmount(record.amount || "");
            setRemarks(record.remarks || "");
        }
    }, [record, isOpen]);


    useEffect(() => {
        const fetchBalance = async () => {
            if (!record?.from_type) return;
            setLoadingBalance(true);

            try {
                const payload = {
                    store_id: record?.store_id || record?.from_store_id || record?.to_store_id,
                    from_type: record?.from_type, // "Cash" or "Bank"
                };
                const res = await getTransferBalance(payload);

                console.log("resssssss---->, ", res);


                if (res?.status_code === 200) {
                    const balanceAmount = parseFloat(res?.balance || 0);
                    setBalance(balanceAmount);
                } else {
                    setBalance(0);
                }
            } catch (err) {
                console.error("Balance fetch error:", err);
                setBalance(0);
            } finally {
                setLoadingBalance(false);
            }
        };

        if (isOpen && record) {
            fetchBalance();
        }
    }, [isOpen, record]);


    const handleSave = async () => {

        const numericAmount = parseFloat(amount);
        if (!amount) {
            toast.error(t("Please enter a valid the amount"));
            return;
        }

        if (!amount || isNaN(numericAmount)) {
            toast.error(t("Please enter a valid amount"));
            return;
        }
        if (numericAmount <= 0) {
            toast.error(t("Amount must be greater than zero"));
            return;
        }
        if (numericAmount < 10) { // 🔸 Example minimum threshold
            toast.error(t("Amount must be at least 10"));
            return;
        }
        if (balance < 0) {
            toast.error(t("You don’t have enough funds to make this transfer"));
            return;
        }

        if (balance !== null && numericAmount > balance) {
            toast.error(t("Entered amount exceeds available balance"));
            return;
        }



        if (!remarks || remarks.trim() === "") {
            toast.error(t("Please enter a remark"));
            return;
        }


        const payload = {
            record_id: record.id,
            from_type: record.from_type,
            to_type: record.to_type,
            amount: Number(amount),
            remarks: remarks || "",
            is_delete: false,
        };

        const res = await editOrDeleteMoneyTransfer(payload);

        if (res?.result?.status_code === 200) {
            toast.success(t("Money transfer updated successfully"));
            onUpdate();
            onClose();
        } else {
            toast.error(t("Failed to update money transfer"));
        }
    };

    if (!isOpen) return null;

    return (
        <>
            <div style={styles.overlay} onClick={onClose}></div>
            <div style={styles.container}>
                <h2 className="text-xl font-bold mb-4">{t("Edit Money Transfer")}</h2>

                {/* From (Disabled) */}
                <div className="flex flex-col mb-2">
                    <label className="text-sm mt-2 mb-1">{t("From Payment Mode")}</label>
                    <Input value={record?.from_type || ""} disabled />
                </div>

                {/* To (Disabled) */}
                <div className="flex flex-col mb-2">
                    <label className="text-sm mt-2 mb-1">{t("To Payment Mode")}</label>
                    <Input value={record?.to_type || ""} disabled />
                </div>

                {/* Amount (Editable) */}
                <div className="flex flex-col">
                    <label className="text-sm mt-2 mb-1">{t("Amount")}</label>
                    <Input
                        type="number"
                        placeholder={t("Enter Amount")}
                        value={amount}
                        onChange={(e) => {
                            let val = e.target.value;

                            // ✅ Convert to string to check length
                            if (val.replace(".", "").length > 11) return;

                            if (/^[0-9]*\.?[0-9]*$/.test(val)) {
                                const parts = val.split(".");
                                if (parts[1]?.length > 2) return;

                                setAmount(val);
                            }
                        }}
                        maxLength={11}
                        // onChange={(e) => setAmount(e.target.value)}
                        className="h-10 mb-2"
                    />
                    {loadingBalance ? (
                        <p className="text-xs text-gray-500">{t("Fetching balance...")}</p>
                    ) : balance !== null && (
                        <p
                            className={`text-sm italic mb-2 ${balance < 0 ? "text-red font-semibold" : "text-green-600"
                                }`}
                        >
                            {t("Available Balance")}: {balance.toFixed(2)}
                        </p>
                    )}
                </div>

                {/* Remarks (Editable) */}
                <label className="text-sm mt-2 mb-1">{t("Remarks")}</label>
                <Input.TextArea
                    style={styles.input}
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder={t("Enter Remark")}
                />

                {/* Buttons */}
                <div className="flex justify-end gap-4 mt-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 font-semibold text-sm border rounded-lg bg-white text-primaryBlue border-primaryBlue hover:bg-red-600 hover:text-white"
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSave}
                        className="px-4 py-2 font-semibold text-sm border rounded-lg bg-primaryBlue text-white border-primaryBlue hover:bg-red-600"
                    >
                        {t("Save")}
                    </button>
                </div>
            </div>
        </>
    );
};

export default EditMoneyModal;
